import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dc5d366"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"max-width":"500px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please provide the details of your Microsoft Azure tenant and app:", -1))
const _hoisted_3 = { class: "form-group mt-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "client_id" }, "Client ID", -1))
const _hoisted_5 = { class: "form-group mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "client_secret" }, "Client Secret", -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "p-5 d-flex align-items-center justify-content-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-fw fa-2x" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Add Microsoft Account",
    onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'external-systems' })))
  }, {
    default: _withCtx(() => [
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "client_id",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client_id) = $event)),
                placeholder: "Enter client ID"
              }, null, 512), [
                [_vModelText, _ctx.client_id]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "client_secret",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.client_secret) = $event)),
                placeholder: "Enter client secret"
              }, null, 512), [
                [_vModelText, _ctx.client_secret]
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary mt-3",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveAndRedirect())),
              disabled: !_ctx.client_id || !_ctx.client_secret
            }, "Save & authenticate", 8, _hoisted_7)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
    ]),
    _: 1
  }))
}